import {RawAxiosRequestHeaders} from 'axios';

// This is not used on the web, there will be a .native version of this file picked up by the RN app.
export const httpUserAgent: string | undefined = undefined;
export const httpDefaultHeaders: RawAxiosRequestHeaders | undefined = undefined;
